import React from 'react';
import { Redirect } from 'react-router-dom';
import { postData } from '../utility';
import Input from './Input';

function QuickSubscribe({ size }) {
  const [state, setState] = React.useState({
    email: '',
    zip: ''
  });

  const [errors, setErrors] = React.useState({});

  const [complete, setComplete] = React.useState(false);

  function onChange(event) {
    event.preventDefault();
    const newState = Object.assign({}, state);
    newState[event.target.name] = event.target.value;
    setState(newState);
    if (errors[event.target.name]) {
      const newErrors = Object.assign({}, errors);
      delete newErrors[event.target.name];
      setErrors(newErrors);
    }
  }

  function onClick(event) {
    event.preventDefault();
    setErrors({});
    postData('/api/subscription', {
      action: 'subscribe_quick',
      email: state.email,
      zip: state.zip,
      queryString: window.location.search ? window.location.search.slice(1) : ""
    })
      .then(data => {
        if (data.status === 'ok') {
          setComplete(true);
        } else {
          setErrors(data.errors);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  if (complete) {
    return <Redirect push to={{ ...window.location, pathname: './QuickSubscribeThanks' }} />;
  }

  return (
    <form className={`quick-subscribe-${size}-form`}>
      <h1 className={`quick-subscribe-${size}-banner`}>Subscribe</h1>
      <hr className={`quick-subscribe-${size}-border`} />
      <p className={`quick-subscribe-${size}-lead`}>Get our newsletter delivered to<br />your electronic mailbox!</p>
      <div className={`quick-subscribe-${size}-input-box`}>
        <Input type="text" autoComplete="email" className={`quick-subscribe-${size}-input`} error={errors.email} id="email" name="email" label="Email Address" placeholder="username@example.com" value={state.email} onChange={onChange} />
        <Input type="text" autoComplete="postal-code" className={`quick-subscribe-${size}-input`} error={errors.zip} id="zip" name="zip" label="Zip Code" placeholder="12345" value={state.zip} onChange={onChange} />
        <a className={`quick-subscribe-${size}-button`} href="/quicksubscribe" onClick={onClick}><div className={`quick-subscribe-${size}-button-left-arrow`}></div>SUBSCRIBE<div className={`quick-subscribe-${size}-button-right-arrow`}></div></a>
      </div>
    </form>
  );
}

export default QuickSubscribe;
